module.exports = __webpack_public_path__ + "static/media/WebConfig.67708605.png";